<template>
  <div class="market-switcher-trigger">
    <div class="market-switcher-trigger__buttons">
      <button
        class="
          market-switcher-trigger__country
          market-switcher-trigger__button
        "
        type="button"
        @click="handleDrawerOpen('countries')"
        @mousedown="loadComponent('market-switcher-drawer')"
        @touchstart="loadComponent('market-switcher-drawer')"
      >
        <img
          class="market-switcher-trigger__flag"
          alt=""
          :src="currentCountry.flagSrc"
          height="14"
          width="22"
        >

        <span
          class="text-body-2xs-link"
          v-text="`${currentCountry.shortName || currentCountry.code} (${currentCountry.currencySymbol})`"
        />
      </button>

      <hr class="market-switcher-trigger__divider">

      <div id="weglot_here"></div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Market switcher trigger (market-switcher-trigger)
 * -----------------------------------------------------------------------------
 * Button to trigger the market switcher overlay.
 *
 *
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MarketSwitcherTrigger',

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      currentCountry: (state) => state['market-switcher'].currentCountry,
    }),

    /**
     * Compute language string.
     * @returns {String}
     */
    languageString() {
      return this.$variable('store.language')?.toUpperCase()
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      setDisplay: 'market-switcher/setDisplay',
    }),

    /**
     * Handle drawer open.
     * @param {String} [display] - What to display in drawer.
     */
    handleDrawerOpen(display = 'countries') {
      this.setDisplay(display)

      this.openOverlay({
        component: 'market-switcher-drawer',
        ignoreDismissed: true,
        clearQueue: false,
        namespace: 'marketSwitcherDrawer',
      })
    },
  },
}
</script>

<style lang="scss">
@import './market-switcher-trigger';
</style>
